import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[50%]">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20creative%20illustration%20of%20various%20social%20media%20icons%20and%20gossip%20elements%20floating%20in%20a%20collage%20style%2C%20warm%20vibrant%20colors%20with%20magazine%20cutout%20aesthetic%2C%20playful%20and%20modern%20design%2C%20clean%20composition%20on%20light%20background&width=800&height=600&seq=category-main-visual&orientation=landscape"
                alt="爆瓜网分类导航"
                className="w-full h-auto object-cover"
                title="爆瓜网分类导航"
              />
            </div>
          </div>

          <div className="lg:w-[50%] flex flex-col justify-center">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-5 w-fit whitespace-nowrap">
              <i className="ri-apps-line text-xs"></i>
              分类导航
            </span>

            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              全网八卦
              <br />
              一站直达
            </h2>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-md">
              六大核心分类，覆盖网红反差、明星八卦、独家揭秘、劲爆内幕等全方位吃瓜内容。无论你对哪个领域感兴趣，这里都有你最想看的爆料。
            </p>

            <div className="grid grid-cols-2 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex items-center gap-3 px-4 py-3 rounded-xl bg-background-50 cursor-pointer hover:bg-background-200 transition-colors duration-200"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</p>
                    <p className="text-xs text-foreground-400 truncate">{cat.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}